import React from 'react';

//components
import AddExtraConditionButton from './elements/AddExtraConditionButton';
import ConditionalValue from './elements/ConditionalValue';
import ToggleCondition from './elements/ToggleCondition';
import RemoveConditionButton from './elements/RemoveConditionButton';

//interfaces
import { IConditionalLogicPanel } from '../interfaces/IConditionalLogicPanel';
import ToggleSelectButton from '../../global/buttons/ToggleSelectButton';



const ConditionalLogicPanel = (
    { 
        panelClassName, 
        title, 
        toggleItems, 
        removeConditionButtonLabel, 
        onAddConditionClick, 
        onRemoveConditionClick,
        combinator,
        setCombinator
    }: IConditionalLogicPanel) => {

    const buttons = (parentId: number) => [
        { 
            id: parentId + 1,
            isDisabled: false,
            label: 'and',
            onButtonClick: () => {setCombinator?.('and')},
            text: 'and'
        },
        { 
            id: parentId + 2,
            isDisabled: false,
            label: 'or',
            onButtonClick: () => {setCombinator?.('or')},
            text: 'or'
        }
    ]

    const selectedItemIndex = combinator === 'and' ? 0 : 1;
    
    return (
        <div className={`conditional-logic-panel ${panelClassName ?? ''}`}>
            {title && <h2 className="title">{title}</h2>}

            {toggleItems.map((item, index) => {
                const { conditionOne, conditionTwo, textConditions, toggleConditions, addToggleOption} = item;
    
                return (
                    <React.Fragment key={item.id || index}>
                    <div className={`toggle-row toggle-row-id-${item.id} ${(textConditions || toggleConditions) ? 'two-rows' : 'one-row'}`}>
                        <ToggleCondition 
                            condition={conditionOne} 
                        />
                        <div className='condition-two-and-three-container'>
                            {conditionTwo && 
                                <ToggleCondition 
                                    condition={conditionTwo} 
                                />
                            }
                            
                            <ConditionalValue
                                textConditions={textConditions}
                                toggleConditions={toggleConditions}
                                onAddConditionalValueClick={addToggleOption}
                            />
                        </div>
                        

                       
                        
                    </div>
                    {toggleItems.length > 1 && index < toggleItems.length - 1 &&
                    <div className='add-remove-condition-wrapper'>
                        <ToggleSelectButton
                            className={'change-condition-button'}
                            selectedItem={buttons(Number(item.id))[selectedItemIndex]}
                            defaultTitle={''}
                            ariaLabel={'select condition type'}
                            buttonList={buttons(Number(item.id))}
                            toggleDisabled={index !== 0}
                        />
                         <RemoveConditionButton 
                            showButton={toggleItems.length > 1} 
                            buttonLabel={removeConditionButtonLabel} 
                            onButtonClick={()=> onRemoveConditionClick(toggleItems[index + 1])}
                        />   
                    </div>
                        
                    }
                    </ React.Fragment>    
                    
                );
            })}

            {!!onAddConditionClick && <AddExtraConditionButton 
                content={toggleItems.length < 1 ? <>+ Add Condition</> : <><span className="add-icon">+</span> {buttons(0)[selectedItemIndex].label}</>} 
                ariaLabel={'Add an additional condition'} 
                onAddConditionClick={onAddConditionClick ?? undefined}
            />}
        </div>
    );
};

export default ConditionalLogicPanel